import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cn from 'classnames'
import _ from 'lodash'
import { navigate } from './constants'
import * as dateMath from 'date-arithmetic'
import Popover from 'antd/lib/popover'
import { Calendar, Button } from 'antd'
import moment from 'moment'
import 'react-day-picker/lib/style.css'
import './css/style.css'
import * as instructorActions from '../../_actions/roster.actions'
import { CALENDAR_VIEWS } from './constants'
import { viewConstants } from '../../_constants/view.constants'

const NORMALWORKING_ACTION = 99

const dateLabel = 'Calendar'

class Toolbar extends React.Component {
    static propTypes = {
        view: PropTypes.string.isRequired,
        views: PropTypes.arrayOf(PropTypes.string).isRequired,
        label: PropTypes.node.isRequired,
        localizer: PropTypes.object,
        onNavigate: PropTypes.func.isRequired,
        onView: PropTypes.func.isRequired,
        showFilters: PropTypes.bool,
        onToggleFilters: PropTypes.func,
        hasActiveFilters: PropTypes.bool,
        menuItems: PropTypes.array,
        endElement: PropTypes.node,
    }

    static defaultProps = {
        showFilters: false,
        hasActiveFilters: false,
    }

    state = {
        visible: false,
        displayLabel: '',
        current: moment(new Date()),
        viewDropdownOpen: false,
    }

    componentDidMount() {
        document.addEventListener('mousedown', this._handleOutsideClick)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._handleOutsideClick)
    }

    _handleOutsideClick = (e) => {
        if (this._viewDropdown && !this._viewDropdown.contains(e.target)) {
            this.closeViewDropdown()
        }
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    toggleViewDropdown = () => {
        this.setState(s => ({ viewDropdownOpen: !s.viewDropdownOpen }))
    }

    closeViewDropdown = () => {
        this.setState({ viewDropdownOpen: false })
    }

    selectView = (v) => {
        this.closeViewDropdown()
        this.props.onView(v)
    }

    getDatelable = date => {
        this.setState({ displayLabel: dateLabel })
    }

    getDatelableCurrent = () => {
        return dateLabel
    }

    displayEmployeeIds = () => {
        const ids = (this.props.displayEmployees || []).map(emp => {
            return emp.EmployeeAutoID
        })
        return ids
    }

    hasActiveFilters = () => {
        const { selectedBranches, selectedDepartments, hasActiveDateRangeFilter } = this.props
        return (
            !_.isEmpty(this.props.selectedEmployees) ||
            !_.isEmpty(selectedBranches) ||
            !_.isEmpty(selectedDepartments) ||
            hasActiveDateRangeFilter
        )
    }

    onSelect = date => {
        const { view } = this.props
        this.setState({
            visible: false,
            current: date,
        })

        const range =
            view === 'month' ? viewConstants.MONTH : viewConstants.WEEK
        const options = {
            range: range,
            time: date.toDate() || new Date(),
        }

        if (this.hasActiveFilters()) {
            if (!_.isEmpty(this.props.selectedEmployees)) {
                options.employees = this.props.selectedEmployees
            } else {
                options.employees = this.displayEmployeeIds()
            }
        }

        if (view === 'month') {
            this.props.actions.rosterActions.fetchUserETime(options)
        } else {
            this.props.actions.rosterActions.fetchUpdateWorkETime(options)
        }

        this.props.actions.rosterActions.updateCurrentDate({
            currentDate: date.toDate(),
        })

        this.props.onNavigate(navigate.DATE, date.toDate())
        this.getDatelable(date)
    }

    navigate = action => {
        const { view } = this.props
        const range =
            view === 'month' ? viewConstants.MONTH : viewConstants.WEEK
        const unit = view === 'month' ? 'month' : 'week'

        const newDate = this.rangeChange(this.props.date, action, range)

        if (navigate.PREVIOUS === action) {
            const previous = dateMath.add(this.state.current.toDate(), -1, unit)
            this.getDatelable(moment(previous))
            this.setState({
                visible: false,
                current: moment(previous),
            })
            this.props.actions.rosterActions.updateCurrentDate({currentDate: newDate})
        } else if (navigate.NEXT === action) {
            const next = dateMath.add(this.state.current.toDate(), 1, unit)
            this.getDatelable(moment(next))
            this.setState({
                visible: false,
                current: moment(next),
            })
            this.props.actions.rosterActions.updateCurrentDate({currentDate: newDate})
        }

        const options = {
            range: range,
            time: newDate || new Date(),
        }

        if (this.hasActiveFilters()) {
            if (!_.isEmpty(this.props.selectedEmployees)) {
                options.employees = this.props.selectedEmployees
            } else {
                options.employees = this.displayEmployeeIds()
            }
        }

        if (view === 'month') {
            this.props.actions.rosterActions.fetchUserETime(options)
        } else {
            this.props.actions.rosterActions.fetchUpdateWorkETime(options)
        }

        this.props.onNavigate(action, this.props.date)
    }

    rangeChange = (date, action, view) => {
        switch (view) {
            case viewConstants.MONTH:
            case CALENDAR_VIEWS.MONTH:
                return this.navigateMonth(date, action)
            case viewConstants.WEEK:
            case CALENDAR_VIEWS.WEEK:
                return this.navigateWeek(date, action)
            default:
                return date
        }
    }

    navigateMonth = (date, action) => {
        switch (action) {
            case navigate.PREVIOUS:
                return dateMath.add(date, -1, 'month')

            case navigate.NEXT:
                return dateMath.add(date, 1, 'month')

            default:
                return date
        }
    }

    navigateWeek = (date, action) => {
        switch (action) {
            case navigate.PREVIOUS:
                return dateMath.add(date, -1, 'week')

            case navigate.NEXT:
                return dateMath.add(date, 1, 'week')

            default:
                return date
        }
    }

    refreshCurrentMonth = () => {
        const { selectedEmployees } = this.props
        const options = {
            range: viewConstants.MONTH,
            time: this.state.current.toDate(),
        }

        if (this.hasActiveFilters()) {
            if (!_.isEmpty(selectedEmployees)) {
                options.employees = selectedEmployees
            } else {
                options.employees = this.displayEmployeeIds()
            }
        }

        this.props.actions.rosterActions.fetchUserETime(options)
    }

    refreshCurrentWeek = () => {
        const { selectedEmployees } = this.props
        const options = {
            range: viewConstants.WEEK,
            time: this.state.current.toDate(),
        }

        if (this.hasActiveFilters()) {
            if (!_.isEmpty(selectedEmployees)) {
                options.employees = selectedEmployees
            } else {
                options.employees = this.displayEmployeeIds()
            }
        }

        this.props.actions.rosterActions.fetchUpdateWorkETime(options)
    }

    view = view => {
        this.props.onView(view)
    }

    viewNamesGroup(messages) {
        let viewNames = this.props.views || []
        const view = this.props.view

        if (viewNames.length > 1) {
            return viewNames.map(name => (
                <button
                    type="button"
                    key={name}
                    className={cn({ 'rbc-active': view === name })}
                    onClick={this.view.bind(null, name)}
                >
                    {messages[name]}
                </button>
            ))
        }
    }

    render() {
        let {
            localizer,
            label,
            showFilters,
            onToggleFilters,
            hasActiveFilters,
            view,
            views,
            onView,
            menuItems,
            endElement,
        } = this.props

        const messages = localizer?.messages || {}

        let { displayLabel } = this.state

        let popover = (
            <div className="popover-calendar">
                <Calendar fullscreen={false} onSelect={this.onSelect} />
            </div>
        )

        let monthRange = label
        let year = ''

        if (view === 'month') {
            const parts = label.split(' ')
            if (parts.length >= 2) {
                monthRange = parts[0]
                year = parts[parts.length - 1]
            }
        } else {
            // Week view label: "May 11 – 17, 2026" — strip comma+year for bold range
            const commaIndex = label.lastIndexOf(',')
            if (commaIndex !== -1) {
                monthRange = label.substring(0, commaIndex).trim()
                year = label.substring(commaIndex + 1).trim()
            }
        }

        const navGroup = view === 'month' ? (
            /* Month navigation: < | Month | > | refresh */
            <span className="date-navigation-group date-nav-month">
                <button
                    type="button"
                    className="nav-week-btn nav-week-prev"
                    onClick={this.navigate.bind(null, navigate.PREVIOUS)}
                >
                    <i className="fas fa-angle-left" />
                </button>

                <Popover
                    content={popover}
                    placement="bottom"
                    trigger="click"
                    open={this.state.visible}
                    onOpenChange={this.handleVisibleChange}
                >
                    <div className="nav-week-label">
                        {monthRange}
                    </div>
                </Popover>

                <button
                    type="button"
                    className="nav-week-btn nav-week-next"
                    onClick={this.navigate.bind(null, navigate.NEXT)}
                >
                    <i className="fas fa-angle-right" />
                </button>

                <button
                    type="button"
                    className="nav-week-btn nav-week-today"
                    onClick={this.refreshCurrentMonth}
                    title="Refresh current month"
                >
                    <i className="pi pi-refresh" />
                </button>
            </span>
        ) : (
            /* Week navigation: < | bold date range | > | refresh */
            <span className="date-navigation-group date-nav-week">
                <button
                    type="button"
                    className="nav-week-btn nav-week-prev"
                    onClick={this.navigate.bind(null, navigate.PREVIOUS)}
                >
                    <i className="fas fa-angle-left" />
                </button>

                <Popover
                    content={popover}
                    placement="bottom"
                    trigger="click"
                    open={this.state.visible}
                    onOpenChange={this.handleVisibleChange}
                >
                    <div className="nav-week-label">
                        {monthRange}
                    </div>
                </Popover>

                <button
                    type="button"
                    className="nav-week-btn nav-week-next"
                    onClick={this.navigate.bind(null, navigate.NEXT)}
                >
                    <i className="fas fa-angle-right" />
                </button>

                <button
                    type="button"
                    className="nav-week-btn nav-week-today"
                    onClick={this.refreshCurrentWeek}
                    title="Refresh current week"
                >
                    <i className="pi pi-refresh" />
                </button>
            </span>
        )

        const viewIcon = view === 'month' ? 'pi pi-calendar' : 'pi pi-table'
        const viewLabel = view === 'month' ? 'Month' : 'Week'

        return (
            <div className="rbc-toolbar custom-toolbar">
                <div className="rbc-toolbar-row">

                    {/* 1. View dropdown */}
                    <div className="view-dropdown-wrapper" ref={el => { this._viewDropdown = el }}>
                        <button
                            type="button"
                            className="view-dropdown-btn"
                            onClick={this.toggleViewDropdown}
                        >
                            <i className={viewIcon} />
                            <span>{viewLabel}</span>
                            <i className="pi pi-chevron-down view-dropdown-chevron" />
                        </button>

                        {this.state.viewDropdownOpen && (
                            <div className="view-dropdown-menu">
                                <button
                                    type="button"
                                    className={cn('view-dropdown-item', { 'view-dropdown-item--active': view === 'week' })}
                                    onClick={() => this.selectView('week')}
                                >
                                    <i className="pi pi-table" />
                                    <span>Week</span>
                                </button>
                                <button
                                    type="button"
                                    className={cn('view-dropdown-item', { 'view-dropdown-item--active': view === 'month' })}
                                    onClick={() => this.selectView('month')}
                                >
                                    <i className="pi pi-calendar" />
                                    <span>Month</span>
                                </button>
                            </div>
                        )}
                    </div>

                    {/* 2. Filter icon button — matches roster-frontend style */}
                    <button
                        type="button"
                        onClick={onToggleFilters}
                        title="Toggle filters"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            border: (showFilters || hasActiveFilters) ? '1px solid #2563EB' : '1px solid #E5E7EB',
                            background: (showFilters || hasActiveFilters) ? '#EFF6FF' : '#fff',
                            color: (showFilters || hasActiveFilters) ? '#2563EB' : '#374151',
                            borderRadius: 6,
                            width: 32,
                            height: 32,
                            padding: 0,
                            flexShrink: 0,
                            position: 'relative',
                        }}
                    >
                        <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                        </svg>
                        {hasActiveFilters && (
                            <span style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                width: 6,
                                height: 6,
                                background: '#2563EB',
                                borderRadius: '50%',
                            }} />
                        )}
                    </button>

                    {/* 3. Navigation: < | date range | > | refresh */}
                    {navGroup}

                </div>

                <div
                    className={cn('filter-panel-horizontal', {
                        open: showFilters,
                    })}
                >
                    {this.props.children}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        displayEmployees: state.roster.displayEmployees,
        selectedEmployees: state.roster.selectedEmployees,
        selectedBranches: state.roster.selectedBranches,
        selectedDepartments: state.roster.selectedDepartments,
        hasActiveDateRangeFilter: state.roster.hasActiveDateRangeFilter,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            rosterActions: bindActionCreators(instructorActions, dispatch),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar)
